import G6 from "@antv/g6";

const menu = (that)=>{
  return new G6.Menu({
    offsetX: 6,
    offsetY: 10,
    itemTypes: ['node'],
    getContent(e) {
      const outDiv = document.createElement('div');
      outDiv.style.width = '180px';
      outDiv.innerHTML = `<ul>
        <li code="editorNode">本级表</li>
        <li code="editorParentNode">父级表</li>
        <li code="editorMeter">编辑信息</li>
        <li code="settingObject">设置客户</li>
        <li code="settingSon">设置下级表</li>
        <li code="deleteItem">移除挂载</li>
      </ul>`
      return outDiv
    },
    shouldBegin(e){
      const { item, target } = e;
      const targetType = target.get('type');
      return targetType!=='image'
    },
    handleMenuClick(target, item) {
      const model=item.getModel();
      const code=target.getAttribute("code")
      // console.log(target, item)
      if(code==='settingSon'){
        if (!model.children) {
          model.children = [];
        }
        that.$refs.SelectMeter.show(list=>{
          let meter_ids=list.map(ret=>ret.id);
          that.addPid(model.id,meter_ids,()=>{
            let energy_list=["业主能耗","物业能耗","分摊能耗"];
            list.forEach(ret=>{
              model.children.push(MeterTreeItem(ret,list));
            })
            that.treeGraph.updateChild(model, model.id);
          })
        })
      }else if(code==='deleteItem'){
        that.$confirm('是否确认移除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.deleteMeterPid(model.id,()=>{
            that.treeGraph.removeChild(model.id);
          })
        })
      }else if(code==='settingObject'){
        that.$refs.ApportionWinRef.show({id:model.id})
      }else if(code==='editorMeter'){
        that.$refs.MeterEditorRef.show({id:model.id},true)
      }else if(code==='editorNode'){
        that.setCard("editor");
        setTimeout(function () {
          that.mainObj.map_id=model.id;
          that.setCard("MeterMapEditor");
        },200)
      }else if(code==='editorParentNode'){
        if(model.upid){
          that.setCard("editor");
          setTimeout(function () {
            that.mainObj.map_id=model.upid;
            that.setCard("MeterMapEditor");
          },200)
        }else {
          that.$message.error("无上级了")
        }


      }


    },
  })
};

const tooltip = new G6.Tooltip({
  offsetX: 10,
  offsetY: 20,
  getContent(e) {
    const { item, target } = e;
    const targetType = target.get('type');
    const name = target.get('name');
    const model=item.getModel();
    if(targetType==='image'){
      if(name==='add-item'){
        return '添加下级表';
      }else if(name==='add-user'){
        return '设置收费对象';
      }else {
        return '移除挂载';
      }
    }else {
      return '仪表名称: ' + model.name + '<br/> ' +
        '仪表编号: ' + model.number+ '<br/> ' +
        '能耗类型: ' + model.energy+ '<br/> ' +
        '下级数量: ' + model.count+ '<br/> ' +
        '分摊类型: ' + model.apportion_meter_type+ '<br/> ' +
        '分摊模式: ' + model.apportion_type+ '<br/> ' +
        '分摊人数: ' + model.customer_count+ '<br/> ' +
        '所在级别: ' + model.depth+ '<br/> ' ;
    }

  },
  shouldBegin(e){
    const { item, target } = e;
    const targetType = target.get('type');
    return true;
  },
  itemTypes: ['node']
});

const toolbar = new G6.ToolBar();

const MeterTreeItem = (item,list) => {
  let energy_list=["业主能耗","物业能耗","分摊能耗"];
  let apportion_type_obj={
    average:"平均分摊",
    area:"面积分摊",
    usage:"用量分摊",
    floor:"楼层分摊",
    currency:"通用分摊"
  }
  let apportion_meter_type={
    1:"纯用量分摊",
    2:"线损分摊"
  }
  return {
    id:item.id+'',
    name: item.name||'',
    number:item.number,
    energy:energy_list[item.energy-1],
    count: list.filter(res=>res.upid===item.id).length,
    upid:item.upid,
    apportion_meter_type:apportion_meter_type[item.apportion_meter_type]||'未设置',//仪表分摊类型：1分摊表、2线损表
    apportion_type:apportion_type_obj[item.apportion_type]||'未设置',//分摊模式
    customer_count:item.customer_count||0
  }
}

export {
  menu,tooltip,toolbar,MeterTreeItem
}



// WEBPACK FOOTER //
// ./src/components/Admin/EnergyConsumption/components/meter/components/common/G6Help.js